import React from 'react';
import ShowReview from '../Pages/Home/ShowReview';


const Review = () => {
    return (
        <div>
            <ShowReview></ShowReview>
        </div>
    );
};

export default Review;